import "./Search.html";
import "./Search.scss";

import type { IControllerConstructor, Injectable } from "angular";
import { SearchComponentController } from "./SearchComponentController";

export class SearchComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            isDisabled: "<?",
            partnerId: "@",
        };
        this.controller = SearchComponentController;
        this.templateUrl = "/App/Modules/Gui/Components/Search/Search.html";
    }
}
